<div class="title">
    <div>Neighborhood enrichment</div>
    <button class="wiki-btn" (click)="goToWiki()">?</button>
</div>
<form class="form-container job-selection-dialog-content">
    <cds-form-group layout="vertical">
        <app-multi-select-box
            [title]="'Selections'"
            [items]="selections$ | async"
            (selected)="selectSelections($event)"
        ></app-multi-select-box>
    </cds-form-group>
    <cds-form-group layout="horizontal">
        <cds-input controlWidth="stretch">
            <label>Experiment name</label>
            <input type="text" name="experimentName" [(ngModel)]="experimentName" />
        </cds-input>
        <cds-checkbox-group layout="horizontal-inline">
            <label for="keepBackground">Keep unassigned</label>
            <cds-checkbox>
                <label></label>
                <input
                    id="keepBackground"
                    type="checkbox"
                    name="keepBackground"
                    [(ngModel)]="keepBackground"
                />
            </cds-checkbox>
        </cds-checkbox-group>
        <div class="number-input-row">
            <label for="radius" class="number-input-label">Radius [µm]</label>
            <input
                id="radius"
                class="number-input-no-arrow"
                type="number"
                [min]="1"
                name="radius"
                [(ngModel)]="radius"
            />
        </div>
        <div *ngIf="siblingDatasets!.length > 1">
            <cds-checkbox>
                <label>Run the job on datasets in the same folder</label>
                <input
                    id="runBatchJob"
                    type="checkbox"
                    name="runBatchJob"
                    [(ngModel)]="runBatchJob"
                />
            </cds-checkbox>
            <ul class="batch-datasets" [class.show]="runBatchJob">
                <li *ngFor="let dataset of siblingDatasets">
                    {{ dataset }}
                </li>
            </ul>
        </div>
    </cds-form-group>
</form>
<div class="actions action-buttons">
    <cds-button size="sm" action="flat" (click)="cancel()">Cancel</cds-button>
    <cds-button size="sm" (click)="startJob()" [disabled]="!canStart">Start Job</cds-button>
</div>
